import type { KambiHistoryCoupon, KambiCashOutValue } from '@mobi/api-types/kambi'
import { getFromKambiPlayerApi } from './utils/getFromKambiPlayerApi'

export const getKambiPendingBetHistory = async () => {
  try {
    const response = await getFromKambiPlayerApi<KambiHistoryResponse | null>({
      urlPath: 'coupon/history?range_size=100&range_start=0&status=PENDING',
    })
    return response
  } catch {
    return null
  }
}

export const getKambiPendingBetCoupon = async (couponRef: number) => {
  try {
    const response = await getFromKambiPlayerApi<KambiHistoryCoupon[]>({
      urlPath: `coupon/history/${couponRef}`,
    })
    return response
  } catch {
    return null
  }
}

export const getKambiPendingBetsCashOutStatus = async () => {
  try {
    const response = await getFromKambiPlayerApi<KambiCashOutValue[]>({
      urlPath: `cashout.json?lang=en_AU&market=AU`,
    })
    return response
  } catch {
    return null
  }
}

// =====
// Types
// =====

type KambiHistoryResponse = {
  historyCoupons: KambiHistoryCoupon[]
  range: {
    /** Offset from first. */
    start: number
    /** Number of objects in this range. */
    size: number
    /** true if more results are available. */
    more: boolean
  }
}
